import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { Switch } from 'antd';
import s from './index.module.css';

export const ScheduleInGoogleCalendar = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
       <div className={s.wrapper}>
            <Switch
                checked={state.scheduleInGoogleCalendar}
                onChange={() => {
                    setFieldInState(
                        {
                            field:'scheduleInGoogleCalendar', 
                            value: state.scheduleInGoogleCalendar ? false : true
                        }
                    )
                }}
            />
            <span className={s.text}>Запланировать в Google Calendar</span>
       </div>
    )
}
